import React from "react";
// import AnimatedSection from "./AnimatedSection";
import { useTranslation } from "react-i18next";
import "../i18n"; // Import i18n setup
import { motion } from "framer-motion";

const AboutUs = () => {
    const { t } = useTranslation(["aboutUs"]);

    return (
        <section id="about-us" className="w-full">
            {/* <AnimatedSection> */}
            {/* Changed from container to w-screen for full width background */}
            <div
                className="w-screen relative min-h-[400px] hidden lg:block"
                style={{
                    backgroundImage: 'url("/images/others/AboutBack.svg")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '100vw',
                    marginLeft: 'calc(-50vw + 50%)',
                    marginRight: 'calc(-50vw + 50%)',
                }}
            >
                <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20 py-4 md:py-10 lg:py-20">
                    <div className="w-full p-4">
                        <h2 className="text-5xl font-bold">{t("aboutUs:aboutUs.title")}</h2>
                        <p className="text-left md:text-justify lg:text-justify mt-16 bg-gray-900/90 p-6 rounded-lg backdrop-blur-sm shadow-xl">
                            {t("aboutUs:aboutUs.description")}
                        </p>
                    </div>
                </div>
            </div>

            <div
                className="w-screen relative min-h-[400px] lg:hidden"
            >
                <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20 py-4 md:py-10 lg:py-20">
                    <div className="w-full p-4">
                        <h2 className="text-5xl font-bold">{t("aboutUs:aboutUs.title")}</h2>
                        <p className="text-left md:text-justify lg:text-justify mt-4 bg-gray-900/90 p-6 rounded-lg backdrop-blur-sm shadow-xl">
                            {t("aboutUs:aboutUs.description")}
                        </p>
                    </div>
                </div>
            </div>

            {/* Company Profile Table */}
            <div className="container mx-auto px-6 lg:px-20 mt-4 lg:mt-32">
                <div className="relative overflow-hidden min-h-[600px]">
                    {/* Background Image with Animation */}
                    {/* <motion.div 
                            className="absolute inset-0 z-0"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 0.25, scale: 1 }}
                            transition={{ duration: 1.5 }}
                            style={{
                                backgroundImage: 'url("/images/others/ProfileSide.svg")',
                                backgroundSize: 'contain',
                                backgroundPosition: 'right center',
                                backgroundRepeat: 'no-repeat',
                            }}
                        /> */}

                    {/* Content with Glass Effect and Animations */}
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="relative z-10 bg-gradient-to-r from-gray-900/95 via-gray-900/95 to-gray-900/90 
                                       rounded-2xl shadow-2xl backdrop-blur-lg p-12 border border-gray-700/50"
                    >
                        <motion.h2
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                            className="text-5xl font-bold mb-12 relative inline-block"
                        >
                            {t("aboutUs:companyProfile.title")}
                            <motion.div
                                className="absolute -bottom-4 left-0 w-32 h-1 bg-blue-500"
                                initial={{ width: 0 }}
                                animate={{ width: "100%" }}
                                transition={{ duration: 0.8, delay: 0.6 }}
                            />
                        </motion.h2>

                        <div className="overflow-x-auto mt-8">
                            <table className="w-full border-collapse border-0">
                                <tbody className="divide-y divide-gray-700/50">
                                    {[
                                        'companyName',
                                        'established',
                                        'representative',
                                        'headOffice',
                                        'capital',
                                        'fiscalYear',
                                        'businessContents',
                                        'tagline',
                                        'legalStructure',
                                        'businessType',
                                        'website',
                                        'contact'
                                    ].map((field, index) => (
                                        <motion.tr
                                            key={field}
                                            initial={{ opacity: 0, x: -20 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            transition={{ duration: 0.5, delay: 0.1 * index }}
                                            className="hover:bg-gray-800/50 transition-all duration-300 ease-in-out"
                                        >
                                            <td className="py-4 px-6 text-gray-300 font-semibold w-1/3">
                                                {t(`aboutUs:companyProfile.${field}`)}
                                            </td>
                                            <td className="py-4 px-6 text-white">
                                                {t(`aboutUs:companyProfile.values.${field}`)}
                                            </td>
                                        </motion.tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </motion.div>

                    {/* Enhanced Decorative Elements */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 0.15, scale: 1 }}
                        transition={{ duration: 1 }}
                        className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl z-0"
                    />
                    <motion.div
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 0.15, scale: 1 }}
                        transition={{ duration: 1, delay: 0.5 }}
                        className="absolute bottom-0 left-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl z-0"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 container mx-auto text-center text-3xl font-bold pt-10 px-6 lg:px-20 mt-16">
                {/* Mission */}
                <a href="/about/corporatephilosophy#mission" className="group relative h-64 p-4 hover:opacity-90 text-center text-3xl font-bold overflow-hidden flex items-center justify-center">
                    <img
                        src="/images/others/Mission.gif"
                        alt="Mission"
                        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform rounded-lg shadow-lg"
                    />
                </a>

                {/* Vision */}
                <a href="/about/corporatephilosophy#vision" className="group relative h-64 p-4 hover:opacity-90 text-center text-3xl font-bold overflow-hidden flex items-center justify-center">
                    <img
                        src="/images/others/Vision.gif"
                        alt="Vision"
                        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform rounded-lg shadow-lg"
                    />
                </a>

                {/* Core Values */}
                <a href="/about/corporatephilosophy" className="group relative h-64 p-4 hover:opacity-90 text-center text-3xl font-bold overflow-hidden flex items-center justify-center">
                    <img
                        src="/images/others/CoreValues.gif"
                        alt="Core Values"
                        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform rounded-lg shadow-lg"
                    />
                </a>
            </div>



            {/* Mission Content */}
            {/* <div className="flex flex-col lg:flex-row p-10">
                    <div className="w-full text-justify p-4">
                        <h2 className="text-3xl font-bold">{t("aboutUs.mission.title")}</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>{t("aboutUs.mission1")}</li>
                            <li>{t("aboutUs.mission2")}</li>
                            <li>{t("aboutUs.mission3")}</li>
                            <li>{t("aboutUs.mission4")}</li>
                            <li>{t("aboutUs.mission5")}</li>
                            <li>{t("aboutUs.mission6")}</li>
                        </ul>
                    </div>
                </div> */}



            {/* Vision Content */}
            {/* <div className="flex flex-col lg:flex-row p-10">
                    <div className="w-full text-justify p-4">
                        <h2 className="text-3xl font-bold">{t("aboutUs.vision.title")}</h2>
                        <p className="mt-2">{t("aboutUs.vision.description")}</p>
                    </div>
                </div> */}

            {/* Core Values Content */}
            {/* <div className="flex flex-col lg:flex-row p-10">
                    <div className="w-full text-justify p-4">
                        <h2 className="text-3xl font-bold">{t("aboutUs.coreValues.title")}</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>{t("aboutUs.coreValues1")}</li>
                            <li>{t("aboutUs.coreValues2")}</li>
                            <li>{t("aboutUs.coreValues3")}</li>
                            <li>{t("aboutUs.coreValues4")}</li>
                            <li>{t("aboutUs.coreValues5")}</li>
                            <li>{t("aboutUs.coreValues6")}</li>
                        </ul>
                    </div>
                </div> */}
            {/* </AnimatedSection> */}
        </section>
    );
};

export default AboutUs;